"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainFiltersWidget = void 0;
var React = _interopRequireWildcard(require("react"));
var _valuationUtilsComponent = require("@cian/valuation-utils-component");
var _useRoomsCountSelectorProps = require("./utils/roomsCountSelector/useRoomsCountSelectorProps");
var _useAreaInputProps = require("./utils/useAreaInputProps");
var _useAddressProps = require("./utils/addressProps/useAddressProps");
var _useEstimationTargetProps = require("./utils/useEstimationTargetProps");
var _Layout = require("../../components/Layout");
var _useJkRoomsCountSelectorProps = require("./utils/jkRoomsCountSelector/useJkRoomsCountSelectorProps");
var _widgetContext = require("../../context/widgetContext");
var _useHouseAreaInputProps = require("./utils/useHouseAreaInputProps");
var _useLandAreaInputProps = require("./utils/useLandAreaInputProps");
var _useRoomNumberInputProps = require("./utils/roomNumberProps/useRoomNumberInputProps");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable  @typescript-eslint/no-explicit-any */

const MainFiltersWidget = _ref => {
  let {
    targetPage,
    isWebview,
    isEmbedded,
    isMyHome,
    withRoomNumber
  } = _ref;
  const isDesktop = (0, _valuationUtilsComponent.useIsDesktop)();
  const roomsCountSelectorProps = (0, _useRoomsCountSelectorProps.useRoomsCountSelectorProps)({
    isMyHome
  });
  const jkRoomsCountSelectorProps = (0, _useJkRoomsCountSelectorProps.useJkRoomsCountSelectorProps)();
  const areaProps = (0, _useAreaInputProps.useAreaInputProps)({
    isMyHome
  });
  const houseAreaProps = (0, _useHouseAreaInputProps.useHouseAreaInputProps)({
    isMyHome
  });
  const landAreaProps = (0, _useLandAreaInputProps.useLandAreaInputProps)({
    isMyHome
  });
  const estimationTargetProps = (0, _useEstimationTargetProps.useEstimationTargetProps)({
    isMyHome
  });
  const addressProps = (0, _useAddressProps.useAddressProps)({
    targetPage,
    isDesktop,
    isMyHome
  });
  const roomNumberProps = (0, _useRoomNumberInputProps.useRoomNumberInputProps)({
    isMyHome,
    withRoomNumber
  });
  return /*#__PURE__*/React.createElement(_widgetContext.Provider, {
    value: {
      isDesktop,
      targetPage,
      isWebview,
      isMyHome,
      withRoomNumber
    }
  }, /*#__PURE__*/React.createElement(_Layout.Layout, {
    areaProps: areaProps,
    houseAreaProps: houseAreaProps,
    landAreaProps: landAreaProps,
    roomsCountSelectorProps: roomsCountSelectorProps,
    addressProps: addressProps,
    roomNumberProps: roomNumberProps,
    estimationTargetProps: estimationTargetProps,
    jkRoomsCountSelectorProps: jkRoomsCountSelectorProps,
    isEmbedded: isEmbedded
  }));
};
exports.MainFiltersWidget = MainFiltersWidget;
MainFiltersWidget.displayName = 'MainFiltersWidget';